var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inscribed h-100"},[_c('Table',{attrs:{"fields":_vm.fields,"league":this.$parent.league,"category":"inscribed","smallScreen":_vm.smallScreen,"getHref":this.getHref}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }